import React from 'react';
import LiveContext from '../../../contexts/LiveContext';
import { SPORTS_TO_SHOW_WITHOUT_TIME } from '../../../data/constants';
import { getStreamingId } from '../../../data/streaming/streamingUtils';
import { classIf, getConfiguration, getPrincipaleOPrimoGruppo } from '../../../data/utils';
import StreamingIcon from '../../../live/common/StreamingIcon';
import { FavoritesContext } from '../../FavoritesContextProvider';
import MenuMatchItemOdd from '../../MenuMatchItemOdd';
import Jersey from '../../../data/jerseys/Jersey';
import { concatUrlPathnames } from '../../../data/sport-utils';
import { appConfig } from '../../../InitData';
import MainContext from '../../../contexts/MainContext';
import { SeoContext } from '../../../data/seo/SeoContextProvider';

function MenuMatchItem(props) {
    const mainContext = React.useContext(MainContext);
    const liveContext = React.useContext(LiveContext);
    const seoContext = React.useContext(SeoContext);
    const favoritesContext = React.useContext(FavoritesContext);
    const streamingId = getStreamingId(props.streaming);
    const isFavorite = favoritesContext.favorites[props.uniqueId] !== undefined;
    const conf = getConfiguration();

    function handleClick() {
        const handlePrematchLiveEventSameUrl = conf.seoplesu;
        if(handlePrematchLiveEventSameUrl) {
            liveContext.setMatchDataPalAvv({
                            sportId: props.sportRef,
                            countryId: props.categoryRef,
                            tournamentId: props.tournamentRef,
                            pal: props.pal,
                            avv: props.avv
                        }, true);
                        let callback = () =>{
                            setTimeout(() => {
                                const path = concatUrlPathnames(appConfig.ROUTES['prematch']['top-match'],props.urlPathSeo);
                                window.history.replaceState(window.history.state, null, path);
                                seoContext.refreshPathname(props.urlPath, mainContext.currentSection.current);
                            }, 5)
                        } 
                        window.openSection('live-match',callback);
        }else{
            liveContext.changeMatch(props.sportRef, props.categoryRef, props.tournamentRef, props.id);
        }
    }

    function toggleFavorite(e) {
        const idAggregata = getPrincipaleOPrimoGruppo(props.gruppiScommessa).idAggregata;
        favoritesContext.toggleFavorite(props.matchData, idAggregata);
        e.stopPropagation();    // Per non selezionare l'evento corrente al click del bottone
    }

    const betWidgetEvento = props.gruppiScommessa?.find(g => g.isPrincipale)?.scommesse[0];
    const parts = props.score.combinedScore.split(' - ');
    let team1Score = parts?.[0] ?? '';
    let team2Score = parts?.[1] ?? '';
    // const matchHref = getLiveMatchPathname()+getLiveMatchWindowLocationHash(props.sportRef, props.categoryRef, props.tournamentRef, props.id);

    return (
        <div className={"sotto-widget-evento bg-bianco nero bordo-tondo padding-orizzontale padding-verticale pointer" + classIf(liveContext.currentMatch && liveContext.currentMatch.id === props.id, 'evento-attivo')} onClick={handleClick}>
        {conf.iwh && <div className='currentMinute__wrapper'> {props.score.currentMinute && !SPORTS_TO_SHOW_WITHOUT_TIME.has(props.sportRef) &&
                    <span className="lampeggia grassetto grigio-scuro">{props.score.currentMinute}</span>
                }</div>}
           {/*  <a href={matchHref} rel="nofollow" className="anchor-live-match" > */}
                <div className="prima-riga-sotto-widget d-grid dueColonne">
                    <div className={`d-flex items-center score__team1-wrapper  ${!team1Score && 'no__score'}`}>
                        {props.team2 &&
                            <Jersey data={props.jerseys?.[0]} type={'home'} sportRef={props.sportRef} />
                        }
                        <span className="nome-squadra-widget name__team1">{props.team1}</span>
                    </div>
                    <span className={`risultato-widget grassetto allinea-dx  ${team1Score ? 'score__team1' : 'no__score'}`}>{team1Score}</span>
                    {props.team2 &&
                        <>
                            <div className={`d-flex items-center score__team2-wrapper  ${!team2Score && 'no__score'}`}>
                                <Jersey data={props.jerseys?.[1]} type={'away'} sportRef={props.sportRef} />
                                <span className="nome-squadra-widget name__team2">{props.team2}</span>
                            </div>
                            <span className={`risultato-widget grassetto allinea-dx  ${team2Score ? 'score__team2' : 'no__score'}`}>{team2Score}</span>
                        </>
                    }
                </div>
           {/*  </a> */}
            <br></br>
            <div className="tabellaQuoteRisultatiParziali">
                <div className="tabellaQuoteRisultatiParziali-contenitoreRisultati d-flex">
                    {props.score.currentScore?.[1]?.score2?.length > 0 &&
                        <div className="tabellaQuoteRisultatiParziali-risultatoParziale">
                            <p className="font-weight-bold"><span>{props.score.currentScore[1].score2.split('#')[0]}</span>{" (" + (props.score.currentScore[1].score2.split('#')[1]+ ")").replace(/\s+/g, '')}</p>
                        </div>
                    }
                    {props.score.currentScore?.[2]?.score3?.length > 0 &&
                        <div className="tabellaQuoteRisultatiParziali-risultatoParziale">
                            <p className="font-weight-bold"><span>{props.score.currentScore[2].score3.split('#')[0]}</span>{" (" + (props.score.currentScore[2].score3.split('#')[1]+ ")").replace(/\s+/g, '')}</p>
                        </div>
                    }
                    {props.score.currentScore?.[3]?.score4?.length > 0 &&
                        <div className="tabellaQuoteRisultatiParziali-risultatoParziale">
                            <p className="font-weight-bold"><span>{props.score.currentScore[3].score4.split('#')[0]}</span>{" (" + (props.score.currentScore[3].score4.split('#')[1]+ ")").replace(/\s+/g, '')}</p>
                        </div>
                    }                
                </div>
                <div className="tabellaQuoteRisultatiParziali-contenitoreRisultati d-flex">
                    {props.score.currentScore?.[4]?.score5?.length > 0 &&
                        <div className="tabellaQuoteRisultatiParziali-risultatoParziale">
                            <p className="font-weight-bold"><span>{props.score.currentScore[4].score5.split('#')[0]}</span>{" (" + (props.score.currentScore[4].score5.split('#')[1]+ ")").replace(/\s+/g, '')}</p>
                        </div>
                    }
                    {props.sportRef !== 4 && props.score.currentScore?.[5]?.score6?.length > 0 &&
                        <div className="tabellaQuoteRisultatiParziali-risultatoParziale">
                            <p className="font-weight-bold"><span>{props.score.currentScore[5].score6.split('#')[0]}</span>{" (" + (props.score.currentScore[5].score6.split('#')[1] + ")").replace(/\s+/g, '')}</p>
                        </div>
                    }
                    {props.sportRef !== 23 && props.score.currentScore?.[6]?.score7?.length > 0 &&
                        <div className="tabellaQuoteRisultatiParziali-risultatoParziale">
                            <p className="font-weight-bold"><span>{props.score.currentScore[6].score7.split('#')[0]}</span>{" (" + (props.score.currentScore[6].score7.split('#')[1] + ")").replace(/\s+/g, '')}</p>
                        </div>
                    }
                </div>
            </div>
            <hr />
            <div className="riga-info-widget-evento d-flex justify-content-between align-items-center margine-giu">
                <span>{props.score.periodo}</span>
                {props.score.currentMinute && !SPORTS_TO_SHOW_WITHOUT_TIME.has(props.sportRef) &&
                    <span className="lampeggia grassetto grigio-scuro">{props.score.currentMinute}</span>
                }
                <div className="icone-info-evento">
                    {streamingId && 
                    
                    <StreamingIcon src="assets\img\sport\icone\tv-streaming.svg" alt="" className="img-tv-streaming" />
                    }
                    <i className={"fas fa-star " + (isFavorite ? " giallo" : " grigio")} onClick={toggleFavorite}></i>
                </div>
            </div>
            <div className="quote-widget-evento d-grid treColonne">
                {betWidgetEvento?.odds?.map(function(o, i) {
                    return <MenuMatchItemOdd  key={i} {...o} matchData={props.matchData} /> 
                })
             }
            </div>
        </div>
    );
}
    
export default MenuMatchItem;